<template>
  <div class="progress">
    <div
      class="progress-bar bg-success"
      role="progressbar"
      :style="{ width: progressWidth }"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      {{ progressLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progressLabel: String,
    progressPercent: Number,
  },
  computed: {
    progressWidth() {
      return `${this.progressPercent}%`;
    },
  },
};
</script>
